import { Component, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import {TranslationService} from "../../../../../modules/i18n";
import {TranslateService} from "@ngx-translate/core";

export interface asideMenu {
  type: 'single' | 'separator' | 'label' | 'dropdown',
  name?: string,
  path?: string,
  icon?: string,
  dataLink?: string,
  items?: dropdownItemAsideMenu[]
  permissions?: string[]
}

export interface dropdownItemAsideMenu {
  name: string,
  path: string,
  permissions?: string[]
}

@Component({
  selector: 'app-aside-menu',
  templateUrl: './aside-menu.component.html',
  styleUrls: ['./aside-menu.component.scss'],
})
export class AsideMenuComponent {

  public activeItem: asideMenu;

  asideMenu: asideMenu[] = [];

  constructor(private router: Router, private cdRef: ChangeDetectorRef, private translate: TranslateService) {
    this.initActiveMenu();
    this.asideMenu = [
      {
        type: 'single',
        name: translate.instant('menu.dashboard'),
        path: '/dashboard',
        icon: 'graphs/gra008.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.account'),
        path: '/il-mio-account',
        icon: 'communication/com013.svg'
      },
      {
        type: 'separator',
        permissions: ['manage-users-show-role-1', 'manage-users-show-role-3', 'manage-users-show-role-5', 'manage-users-show-role-6', 'manage-users-show-role-7', 'manage-users-show-role-8', 'manage-users-show-role-2', 'manage-users-show-role-9', 'manage-users-show-role-4'],
      },
      {
        type: 'label',
        permissions: ['manage-users-show-role-1', 'manage-users-show-role-3', 'manage-users-show-role-5','manage-users-show-role-6', 'manage-users-show-role-7', 'manage-users-show-role-8', 'manage-users-show-role-2', 'manage-users-show-role-9', 'manage-users-show-role-4'],
        name:  translate.instant('menu.gestione-utenti'),
      },
      {
        type: 'single',
        name: translate.instant('menu.ruoli'),
        permissions: ['do-anything'],
        path: '/utenti/gestione-utenti/lista-utenti',
        icon: 'communication/com006.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.nuovo-utente'),
        permissions: ['do-anything'],
        path: '/utenti/gestione-utenti/nuovo-utente',
        icon: 'communication/com019.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.amministrazione'),
        permissions: ['manage-users-show-role-1'],
        path: '/utenti/ruolo/1',
        icon: 'general/gen049.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.segreterie'),
        permissions: ['manage-users-show-role-3'],
        path: '/utenti/ruolo/3',
        icon: 'electronics/elc004.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.legali-infortunistica'),
        permissions: ['manage-users-show-role-5'],
        path: '/utenti/ruolo/5',
        icon: 'finance/fin006.svg'
      },
      {
        type: 'dropdown',
        name: translate.instant('menu.medici'),
        permissions: ['manage-users-show-role-6', 'manage-users-show-role-7', 'manage-users-show-role-8'],
        icon: 'medicine/med001.svg',
        dataLink: '/utenti/ruolo',
        items: [
          {
            name: translate.instant('menu.medici.direzione'),
            permissions: ['manage-users-show-role-6'],
            path: '/utenti/ruolo/6',
          },
          {
            name: translate.instant('menu.medici.operativo'),
            permissions: ['manage-users-show-role-7'],
            path: '/utenti/ruolo/7',
          },
          {
            name: translate.instant('menu.medici.specialista'),
            permissions: ['manage-users-show-role-8'],
            path: '/utenti/ruolo/8',
          },
        ]
      },
      {
        type: 'dropdown',
        name: translate.instant('menu.informatori'),
        permissions: ['manage-users-show-role-2', 'manage-users-show-role-9'],
        icon: 'communication/com005.svg',
        dataLink: '/utenti/ruolo',
        items: [
          {
            name: translate.instant('menu.informatori'),
            permissions: ['manage-users-show-role-2'],
            path: '/utenti/ruolo/2',
          },
          {
            name: translate.instant('menu.informatori.responsabili'),
            permissions: ['manage-users-show-role-9'],
            path: '/utenti/ruolo/9',
          }
        ]
      },
      {
        type: 'single',
        name: translate.instant('menu.assistiti'),
        permissions: ['manage-users-show-role-4'],
        path: '/utenti/ruolo/4',
        icon: 'communication/com018.svg'
      },
      {
        type: 'separator',
        permissions: ['pratiche-list', 'pratiche-create'],
      },
      {
        type: 'label',
        name: translate.instant('menu.gestione-pratiche'),
        permissions: ['pratiche-list', 'pratiche-create'],
      },
      {
        type: 'single',
        name: translate.instant('menu.pratiche'),
        permissions: ['pratiche-list'],
        path: '/pratiche/lista-pratiche',
        icon: 'communication/com016.svg'
      },
      {
        type: 'single',
        name: translate.instant('menu.nuova-pratica'),
        permissions: ['pratiche-create'],
        path: '/pratiche/nuova-pratica/step/1',
        icon: 'general/gen041.svg'
      },
      {
        type: 'dropdown',
        name: translate.instant('menu.malasanità'),
        permissions: ['pratiche-list'],
        icon: 'medicine/med010.svg',
        dataLink: '/pratiche/tipologia',
        items: [
          {
            name: translate.instant('menu.malasanità.pre-perizia'),
            path: '/pratiche/tipologia/PRP',
          },
          {
            name: translate.instant('menu.malasanità.perizia-responsabilità-garantita'),
            path: '/pratiche/tipologia/PR-RG',
          },
          {
            name: translate.instant('menu.malasanità.perizia-responsabilità-medica'),
            path: '/pratiche/tipologia/PR-MD',
          },
          {
            name: translate.instant('menu.malasanità.controffensiva'),
            path: '/pratiche/tipologia/CNTR-M',
          },
        ]
      },
      {
        type: 'dropdown',
        name: translate.instant('menu.incidente-stradale'),
        permissions: ['pratiche-list'],
        icon: 'tools/too001.svg',
        dataLink: '/pratiche/tipologia',
        items: this.translate.currentLang === 'it' ? [
          {
            name: translate.instant('menu.incidente-stradale.quantum-garantito'),
            path: '/pratiche/tipologia/QG',
          },
          {
            name: translate.instant('menu.incidente-stradale.controffensiva'),
            path: '/pratiche/tipologia/CNTR-I',
          },
        ] :
          [
            {
              name: translate.instant('menu.incidente-stradale.quantum-garantito'),
              path: '/pratiche/tipologia/QG',
            },
            {
              name: translate.instant('menu.incidente-stradale.controffensiva'),
              path: '/pratiche/tipologia/CNTR-I',
            },
            {
              name: 'Laboral',
              path: '/pratiche/tipologia/LABORAL',
            }
          ]
      },
      {
        type: 'dropdown',
        name: translate.instant('menu.autopsia'),
        permissions: ['pratiche-list'],
        icon: 'medicine/med009.svg',
        dataLink: '/pratiche/tipologia',
        items: [
          {
            name: translate.instant('menu.autopsia.post-mortem'),
            path: '/pratiche/tipologia/PM',
          },
        ]
      },
      {
        type: 'single',
        name: translate.instant('menu.ctu'),
        permissions: ['pratiche-list'],
        path: '/pratiche/tipologia/CTU',
        icon: 'finance/fin001.svg'
      },
      // {
      //   type: 'single',
      //   name: 'Incomplete',
      //   path: '/pratiche/incomplete',
      //   icon: 'coding/cod011.svg'
      // },
      // {
      //   type: 'single',
      //   name: 'In lavorazione',
      //   path: '/pratiche/in-lavorazione',
      //   icon: 'coding/cod005.svg'
      // },
      // {
      //   type: 'single',
      //   name: 'Concluse',
      //   path: '/pratiche/concluse',
      //   icon: 'communication/com017.svg'
      // },
      // {
      //   type: 'single',
      //   name: 'Cancellate',
      //   path: '/pratiche/cancellate',
      //   icon: 'general/gen027.svg'
      // },
      // {
      //   type: 'separator'
      // },
      // {
      //   type: 'single',
      //   name: 'Impostazioni',
      //   path: '/impostazioni',
      //   icon: 'coding/cod012.svg'
      // },
    ]
  }

  initActiveMenu() {
    this.asideMenu.forEach(item => {
      if (item.type === 'dropdown') {
        item.items?.forEach((dropdownItem: dropdownItemAsideMenu) => {
          if (this.router.url === dropdownItem.path) {
            this.setActiveItem(item);
          }
        });
      }
    });
  }

  setActiveItem(item: asideMenu) {
    this.activeItem = item;
  }
}
